/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
  names: {
    signUpSignIn: 'B2C_1_sign_in_on',
    forgotPassword: 'B2C_1_reset_password',
    editProfile: 'B2C_1_edit_profile',
  },
  authorities: {
    signUpSignIn: {
      authority: 'https://opwell.b2clogin.com/opwell.onmicrosoft.com/B2C_1_sign_in_on',
    },
    forgotPassword: {
      authority: 'https://opwell.b2clogin.com/opwell.onmicrosoft.com/B2C_1_reset_password',
    },
    editProfile: {
      authority: 'https://opwell.b2clogin.com/opwell.onmicrosoft.com/B2C_1_edit_profile',
    },
  },
  authorityDomain: 'opwell.b2clogin.com',
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
const isB2C = process.env.REACT_APP_MSAL_IS_B2C == 'true';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority: isB2C
      ? b2cPolicies.authorities.signUpSignIn.authority
      : process.env.REACT_APP_MSAL_AUTHORITY,
    knownAuthorities: isB2C ? [b2cPolicies.authorityDomain] : [],
    redirectUri: window.location.origin + '/auth/callback',
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};
/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */

export const scopes = ['openid', 'profile', 'offline_access'];

export const protectedResourcesScopes = {
  core: process.env.REACT_APP_MSAL_CORE_SCOPE,
};
